const EMPTY_BRANCH = Object.freeze({
  loading: false,
  success: false,
  error: null,
  errorCode: "",
  status: 0,
  requestId: "",
  retryAfterSeconds: 0,
});

const EMPTY_OPTIONS = Object.freeze({
  ...EMPTY_BRANCH,
  loaded: false,
  products: Object.freeze([]),
  textiles: Object.freeze([]),
  haberdashery: Object.freeze([]),
});

const EMPTY_ENQUIRY = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
  message: "",
  customerUpdateUrl: "",
  customerAccessToken: "",
});

const EMPTY_DRAFT = Object.freeze({
  ...EMPTY_BRANCH,
  draft: null,
});

const EMPTY_DRAFT_UPDATE = Object.freeze({
  ...EMPTY_BRANCH,
  draft: null,
  message: "",
});

const EMPTY_DRAFT_SUBMIT = Object.freeze({
  ...EMPTY_BRANCH,
  draft: null,
  enquiry: null,
  message: "",
  customerUpdateUrl: "",
  customerAccessToken: "",
});

const EMPTY_DRAFT_CLEAR = Object.freeze({
  ...EMPTY_BRANCH,
  draft: null,
  message: "",
});

const EMPTY_QUOTE = Object.freeze({
  ...EMPTY_BRANCH,
  quote: null,
  lineItems: Object.freeze([]),
  delivery: null,
  estimatedTotal: 0,
  estimatedTotalMinor: 0,
  purchasable: true,
  issues: Object.freeze([]),
});

const EMPTY_MY_REQUESTS = Object.freeze({
  ...EMPTY_BRANCH,
  currentRequest: null,
  previousRequests: Object.freeze([]),
  requests: Object.freeze([]),
});

const EMPTY_REQUEST_DETAILS = Object.freeze({
  ...EMPTY_BRANCH,
  request: null,
  enquiry: null,
});

const EMPTY_REQUEST_PAYMENT = Object.freeze({
  ...EMPTY_BRANCH,
  request: null,
  enquiry: null,
  order: null,
  orderNumber: "",
  payment: null,
  hostedCheckoutUrl: "",
  checkoutUrl: "",
  approvalUrl: "",
  approveUrl: "",
  payerActionUrl: "",
  nextAction: null,
  message: "",
});

const EMPTY_PAYMENT_STATUS = Object.freeze({
  ...EMPTY_BRANCH,
  request: null,
  enquiry: null,
  order: null,
  orderNumber: "",
  payment: null,
  pending: false,
  message: "",
});

const EMPTY_CUSTOMER_UPDATE = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
});

const EMPTY_CUSTOMER_RESPONSE = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
  message: "",
});

const EMPTY_ADMIN_LIST = Object.freeze({
  ...EMPTY_BRANCH,
  enquiries: Object.freeze([]),
});

const EMPTY_ADMIN_UPDATE = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
  customerUpdateUrl: "",
  customerAccessToken: "",
  message: "",
});

const EMPTY_ADMIN_QUOTE = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
  quoteUrl: "",
  quoteToken: "",
  customerUpdateUrl: "",
  customerAccessToken: "",
  message: "",
});

const EMPTY_PUBLIC_QUOTE = Object.freeze({
  ...EMPTY_BRANCH,
  quote: null,
});

const EMPTY_ACCEPT_QUOTE = Object.freeze({
  ...EMPTY_BRANCH,
  quote: null,
  order: null,
  orderNumber: "",
  payment: null,
  checkoutUrl: "",
  approvalUrl: "",
  approveUrl: "",
  payerActionUrl: "",
  nextAction: null,
  message: "",
});

const EMPTY_ACCEPT_CUSTOMER_UPDATE = Object.freeze({
  ...EMPTY_BRANCH,
  enquiry: null,
  order: null,
  orderNumber: "",
  payment: null,
  checkoutUrl: "",
  approvalUrl: "",
  approveUrl: "",
  payerActionUrl: "",
  nextAction: null,
  message: "",
});

export const selectMadeToMeasureState = (state) =>
  state?.madeToMeasure || {};

export const selectMadeToMeasureOptions = (state) =>
  selectMadeToMeasureState(state).options || EMPTY_OPTIONS;

export const selectMadeToMeasureEnquiry = (state) =>
  selectMadeToMeasureState(state).enquiry || EMPTY_ENQUIRY;

export const selectMadeToMeasureDraft = (state) =>
  selectMadeToMeasureState(state).draft || EMPTY_DRAFT;

export const selectMadeToMeasureDraftUpdate = (state) =>
  selectMadeToMeasureState(state).draftUpdate || EMPTY_DRAFT_UPDATE;

export const selectMadeToMeasureDraftSubmit = (state) =>
  selectMadeToMeasureState(state).draftSubmit || EMPTY_DRAFT_SUBMIT;

export const selectMadeToMeasureDraftClear = (state) =>
  selectMadeToMeasureState(state).draftClear || EMPTY_DRAFT_CLEAR;

export const selectMadeToMeasureQuote = (state) =>
  selectMadeToMeasureState(state).quote || EMPTY_QUOTE;

export const selectMadeToMeasureMyRequests = (state) =>
  selectMadeToMeasureState(state).myRequests || EMPTY_MY_REQUESTS;

export const selectMadeToMeasureRequestDetails = (state) =>
  selectMadeToMeasureState(state).requestDetails || EMPTY_REQUEST_DETAILS;

export const selectMadeToMeasureRequestPayment = (state) =>
  selectMadeToMeasureState(state).requestPayment || EMPTY_REQUEST_PAYMENT;

export const selectMadeToMeasurePaymentStatus = (state) =>
  selectMadeToMeasureState(state).paymentStatus || EMPTY_PAYMENT_STATUS;

export const selectMadeToMeasureCustomerUpdate = (state) =>
  selectMadeToMeasureState(state).customerUpdate || EMPTY_CUSTOMER_UPDATE;

export const selectMadeToMeasureCustomerResponse = (state) =>
  selectMadeToMeasureState(state).customerResponse || EMPTY_CUSTOMER_RESPONSE;

export const selectMadeToMeasureAdminList = (state) =>
  selectMadeToMeasureState(state).adminList || EMPTY_ADMIN_LIST;

export const selectMadeToMeasureAdminUpdate = (state) =>
  selectMadeToMeasureState(state).adminUpdate || EMPTY_ADMIN_UPDATE;

export const selectMadeToMeasureAdminQuote = (state) =>
  selectMadeToMeasureState(state).adminQuote || EMPTY_ADMIN_QUOTE;

export const selectMadeToMeasurePublicQuote = (state) =>
  selectMadeToMeasureState(state).publicQuote || EMPTY_PUBLIC_QUOTE;

export const selectMadeToMeasureAcceptQuote = (state) =>
  selectMadeToMeasureState(state).acceptQuote || EMPTY_ACCEPT_QUOTE;

export const selectMadeToMeasureAcceptCustomerUpdate = (state) =>
  selectMadeToMeasureState(state).acceptCustomerUpdate ||
  EMPTY_ACCEPT_CUSTOMER_UPDATE;
